<template>
  <div class="sl-setup">
    <h1>Setup</h1>
    <ul class="tab tab-block">
      <li class="tab-item" :class="{'active': storeTabActive}"><a href="#" @click.prevent="activateStoreTab">Stores</a></li>
      <li class="tab-item" :class="{'active': categoryTabActive}"><a href="#" @click.prevent="activateCategoryTab">Categories</a></li>
    </ul>
    <div class="tab-contents">
      <div v-if="storeTabActive && storesAreLoaded">
        <table class="table">
          <tbody>
            <tr v-for="s in stores" :key="s.id">
              <td>{{ s.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="categoryTabActive && categoriesAreLoaded">
        <table class="table">
          <tbody>
          <tr v-for="c in categories" :key="c.id">
            <td>{{ c.name }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="sl-version text-center">
      <code>v{{version}}</code>
    </div>
  </div>
</template>

<script>
/*
  TODO:
    - Categories
      - Add
      - Rename
      - Delete (if no items associated!)
    - Stores
      - Add
      - Rename
      - Delete
    - Get version from package.json...
 */
export default {
  name: 'setup',
  data () {
    return {
      version: process.env.PACKAGE_VERSION,
      storeTabActive: true,
      categoryTabActive: false
    }
  },
  created () {
    this.verifySignedIn()
  },
  methods: {
    activateStoreTab () {
      this.storeTabActive = true
      this.categoryTabActive = false
    },
    activateCategoryTab () {
      this.storeTabActive = false
      this.categoryTabActive = true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(self => {
      self.setPageMeta(to.meta)
    })
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  .sl-setup {
    .tab {
      border-bottom-color: $darkest-color;

      .tab-item {
        a {
          border-bottom-width: 3px;
        }
        &.active {
          a {
            border-color: $link-color;
          }
        }
      }
    }

    .tab-contents {
      padding-top: 1rem;
    }
  }
</style>
